import { LegalDocument } from './LegalDocument';
import { SITE } from '../data/site';

export function CookiePolicy() {
  return (
    <LegalDocument
      title="Cookie Policy"
      intro={`The small set of cookies ${SITE.name} uses — and why each one is here.`}
      lastUpdated={SITE.legalLastUpdated}
      sections={[
        {
          heading: 'What cookies are',
          body: (
            <p>
              Cookies are small text files a website stores in your browser. We use a deliberately
              small set of <strong>first-party</strong> cookies — set by {SITE.name} itself — that are
              essential to running the arcade. We do not use third-party advertising or cross-site
              tracking cookies inside the app.
            </p>
          ),
        },
        {
          heading: 'The cookies we use',
          body: (
            <>
              <ul>
                <li>
                  <strong>Device identifier (<code>a84_did</code>).</strong> A signed, anonymous token
                  that lets us meter free plays fairly and prevent automated abuse. It doesn&rsquo;t
                  identify you personally.
                </li>
                <li>
                  <strong>Session &amp; authentication.</strong> When you sign in, a session cookie
                  keeps you logged in so your scores, tokens, and Pass follow you around the arcade.
                </li>
                <li>
                  <strong>Preferences.</strong> Small local settings — such as sound on/off — so the
                  cabinet remembers how you like to play.
                </li>
              </ul>
            </>
          ),
        },
        {
          heading: 'What we don’t use',
          body: (
            <p>
              We do not embed programmatic ad-network tags, cross-site trackers, or third-party
              analytics cookies in the arcade. Gameplay telemetry is anonymous and stored in our own
              database — it is not tied to advertising cookies. Any promotions you see are our own
              house ads for our games and Passes.
            </p>
          ),
        },
        {
          heading: 'Managing cookies',
          body: (
            <p>
              You can clear or block cookies in your browser settings at any time. Note that the
              device-identifier and session cookies are essential — blocking them may break free-play
              metering, sign-in, and your ability to save scores or use a Pass.
            </p>
          ),
        },
        {
          heading: 'Changes to this policy',
          body: (
            <p>
              As the arcade evolves, this list may change. We&rsquo;ll update the &ldquo;Last
              updated&rdquo; date above whenever it does.
            </p>
          ),
        },
        {
          heading: 'Contact',
          body: (
            <p>
              Questions about cookies? Email{' '}
              <a href={`mailto:${SITE.emails.support}`}>{SITE.emails.support}</a>. See also our{' '}
              <a href="/privacy">Privacy Policy</a>.
            </p>
          ),
        },
      ]}
    />
  );
}
